<template>
  <div
    class="
      member-status-report
      relative
      flex flex-col
      justify-center
      items-center
    "
  >
    <div class="w-full">
      <report-header
        :error.sync="error"
        :range="range"
        :report="report"
        @getReport="getReport"
      >
        <template #title> member status report </template>
        <template #subtitle>
          analyze the status of members in your program
        </template>
      </report-header>
    </div>
    <div v-if="loadingReport" class="flex justify-center align-center mt-12">
      <loading-icon />
    </div>
    <div v-else-if="report" class="w-full mt-4">
      <div class="flex flex-col items-center">
        <div
          v-for="(row, rowIndex) in tableRows"
          :key="rowIndex"
          class="
            member-status-table
            flex
            justify-between
            w-full
            max-w-5xl
            border-b
            border-t-0
            border-r-0
            border-l-0
            border-solid
            p-5
          "
        >
          <div
            class="flex flex-col justify-start items-center w-26 text-center"
          >
            <div class="text-base font-secondary">total members</div>
            <div class="text-2xl">{{formatNumber(row.kpis.total_members)}}</div>
            <div class="text-base" v-if="row.row === 'at_start_date'">enrolled on<br />{{formatDate(range.start)}}</div>
            <div class="text-base" v-else-if="row.row === 'during_date_range'">enrolled<br />during time<br />range</div>
            <div class="text-base" v-else>enrolled on<br />{{formatDate(range.end)}}</div>
          </div>
          <div
            class="flex flex-col justify-start items-center w-26 text-center"
          >
            <div class="text-base font-secondary">allowed sms</div>
            <div class="text-2xl">{{formatNumber(row.kpis.allowed_sms.optedin)}}</div>
            <div class="text-base">{{formatNumber(row.kpis.allowed_sms.optedout)}} opted out</div>
            <div class="text-xs">{{formatNumber(row.kpis.allowed_sms.pending)}} pending</div>
          </div>
          <div
            class="flex flex-col justify-start items-center w-26 text-center"
          >
            <div class="text-base font-secondary">allowed loyalty</div>
            <div class="text-2xl">{{formatNumber(row.kpis.allowed_loyalty.optedin)}}</div>
            <div class="text-base">{{formatNumber(row.kpis.allowed_loyalty.optedout)}} opted out</div>
            <div class="text-xs">{{formatNumber(row.kpis.allowed_loyalty.pending)}} pending</div>
          </div>
          <div
            class="flex flex-col justify-start items-center w-26 text-center"
          >
            <div class="text-base font-secondary">allowed push</div>
            <div class="text-2xl">{{formatNumber(row.kpis.allowed_push.optedin)}}</div>
            <div class="text-base">{{formatNumber(row.kpis.allowed_push.optedout)}} opted out</div>
            <div class="text-xs">{{formatNumber(row.kpis.allowed_push.pending)}} pending</div>
          </div>
          <div
            class="flex flex-col justify-start items-center w-26 text-center"
          >
            <div class="text-base font-secondary">allowed email</div>
            <div class="text-2xl">{{formatNumber(row.kpis.allowed_email.optedin)}}</div>
            <div class="text-base">{{formatNumber(row.kpis.allowed_email.optedout)}} opted out</div>
            <div class="text-xs">{{formatNumber(row.kpis.allowed_email.pending)}} pending</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { subDays } from "date-fns";
import { utcToZonedTime, format } from "date-fns-tz";
import { mapGetters } from "vuex";
import { LoadingIcon } from "@springbig/sb-components";
import { commafyNumber } from "../../utilities";
import { reportsAPI } from "../../services/api/reportsAPI";
import ReportHeader from "./ReportHeader.vue";

export default {
  name: "MemberStatusReport",
  components: {
    LoadingIcon,
    ReportHeader,
  },
  data() {
    return {
      range: null,
      page: 0,
      report: null,
      tableRows: [],
      loadingReport: false,
      error: {},
    };
  },
  async created() {
    await this.$store.dispatch('LOAD_CURRENT_MERCHANT');
    this.range = this.defaultDateRange();
  },
  watch: {
    page() {
      this.getReport();
    },
  },
  computed: {
    pagesTotal() {
      return this.report?.pagination?.total_pages || 1;
    },
    ...mapGetters(["merchantTimeZone"]),
  },
  methods: {
    formatDate(date) {
      return format(date, "MM/dd/yyyy");
    },
    formatNumber(num) {
      return commafyNumber(num);
    },
    defaultDateRange() {
      const currentDate = utcToZonedTime(new Date(), this.merchantTimeZone);
      const minimumDate = subDays(currentDate, 90);

      return {
        min: minimumDate,
        start: minimumDate,
        max: subDays(currentDate, 1),
        end: subDays(currentDate, 1),
      };
    },
    formatReportData() {
      const results = this.report.output_data.results;
      this.tableRows = results;
    },
    createNewReport() {
      return reportsAPI.createReport(
        "Reports::MemberStatusReport",
        this.range.start,
        this.range.end
      );
    },
    fetchExistingReport() {
      return reportsAPI.getReportById(this.report.id, this.page + 1);
    },
    async getReport(newReport) {
      this.loadingReport = true;
      try {
        const { report, pagination } =
          !this.report?.id || (this.report.id && newReport)
            ? await this.createNewReport()
            : await this.fetchExistingReport();
        this.report = { pagination, ...report };
        this.formatReportData();
      } catch (error) {
        this.error.message = "error, please refresh or contact support";
      } finally {
        this.loadingReport = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.member-status-report {
  .member-status-table {
      border-color: rgba(0, 122, 255, 0.3);
  }
}
</style>
